/* SESEN media frames: lazy, muted, in-view video for the offering
   carousels and the homepage media gallery (snippets/sesen-video.liquid).
   - Nothing downloads until the frame is actually on screen. Carousel
     slides scrolled out of their track are clipped, so they never count.
   - A video plays while at least half of it is visible and pauses
     otherwise, so only the active slide / visible tiles ever play.
   - prefers-reduced-motion: the video is never loaded; the poster stays.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var smallScreen = window.matchMedia && window.matchMedia('(max-width: 749px)');

  function load(video) {
    if (video.dataset.sesenLoaded) return true;
    var mobile = smallScreen && smallScreen.matches && video.dataset.srcMobile;
    var src = mobile ? video.dataset.srcMobile : video.dataset.src;
    if (!src) return false;
    video.dataset.sesenLoaded = '1';
    video.dataset.sesenFallback = (mobile ? video.dataset.srcMobileFallback : video.dataset.srcFallback) || '';
    video.src = src;
    return true;
  }

  /* The uploaded original is tried first; if it can't load, use Shopify's
     own transcode of the same file. */
  function fallback(video) {
    var alt = video.dataset.sesenFallback;
    if (!alt || video.getAttribute('src') === alt) return;
    video.dataset.sesenFallback = '';
    video.src = alt;
    play(video);
  }

  function play(video) {
    if (reduceMotion && reduceMotion.matches) return;
    if (!load(video)) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] })
    : null;

  function init(scope) {
    var videos = (scope || document).querySelectorAll('video[data-sesen-video]');
    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.sesenInit) return;
      video.dataset.sesenInit = '1';
      video.muted = true;
      video.addEventListener('error', function () { fallback(video); });
      video.addEventListener('playing', function () {
        var frame = video.closest('.sesen-video');
        if (frame) frame.classList.add('is-playing');
      });
      if (observer) observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
